<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19rXlEc/tc-custom/9781429988667.jpg?1721100060206" alt="This image is the cover for the book Hard Knocks, Jack Reilly"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hard Knocks, Jack Reilly
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times</i>–bestselling true crime author and radio sensation delivers a hard-hitting novel of survival, betrayal, deceit, and murder in Boston.</b><br/><br/>Jack Reilly, a dodgy ex-Boston cop, is trying to make ends meet as a private investigator. When a client is killed, execution style, Reilly finds himself in a whole world of pain. Someone wants him dead—but why? To find out, Reilly must weed through thirty years of duplicity, corruption, and killing . . . a web of politicians dirtier than mobsters and criminals nobler than senators. He needs to uncover the dangerous truth behind the bribery, blood, and backdoor deals that define the highest levels of both organized crime and State House politics—before it’s too late.<br/><br/><b>“A gritty, adventurous romp into the world of politics and mobsters in Boston with enough surprise twists to keep you guessing to the end.” —<i>Criminal Element</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Howie Carr
      </h2>
      
      <p class="authorDescription body article"><P>HOWIE CARR is a columnist for the <I>Boston Herald </I>and author of <I>The Brothers Bulger</I>, which spent eleven weeks on the <I>New York Times </I>bestseller list, and the <I>New York Times </I>bestseller <I>Hitman: The Untold Story of Johnny Martorano</I>, <I>Whitey Bulger's Enforcer and the Most Feared Gangster in the Underworld. </I>Carr hosts a daily four hour radio talk show that is syndicated throughout New England. Carr has won a National Magazine Award, and in 2008 he was elected to the National Radio Hall of Fame. Carr lives in suburban Boston.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e95e83c